import React from 'react';
import { useSelector } from 'react-redux';
import { Dialog, Box } from '@iclinic/design-system';

import {
  isModalOpenSelector,
  stepSelector,
  stepsSelector,
} from '../../state/selectors';

export const CFMStepModal = () => {
  const step = useSelector(stepSelector);
  const steps = useSelector(stepsSelector);
  const isModalOpen = useSelector(isModalOpenSelector);

  const StepComponent = steps?.[step] ?? null;

  return (
    <Dialog open={isModalOpen} disableEscapeKeyDown maxWidth="md">
      <Box width="560px">
        <Box mx={3} my={2}>
          {StepComponent}
        </Box>
      </Box>
    </Dialog>
  );
};
